const zhCN = {
  home: '首页',
  userCenter: '个人中心',
  // changePassword: '修改密码',
  orgMana: '组织管理',
  personalMana: '人员管理',
  newPersonal: '新增人员',
  editPersonal: '修改人员',
  editAuth: '修改授权',
  authBatch: '批量设备授权',
  devicesMana: '设备管理',
  deviceActiveTime: '门禁有效时间',
  deviceConfig: '设备配置',
  timeConfig: '时间配置',
  visitorMana: '访客管理',
  visitorSettings: '访客设置',
  reservedVisitor: '预约记录',
  visitorRecord: '到访记录',
  visitorPath: '访客路径规划',
  blackList: '黑 名 单',
  identificationRecord: '识别记录',
  warningMana: '预警记录',
  alarmMana: '报警记录',
  logMana: '日志管理',
  operationLog: '操作日志',
  workLog: '设备工作日志',
  syncLog: '数据同步日志',
  repeatData: '重复数据查询',
  financial: '应用市场',
  recharge: '商品购买',
  orders: '订单详情',
  invoices: '发票查询',
  invoicesApply: '申请发票',
  serviceLog: '短信账户变动记录',
  sysRepeatDataWarn: (count) => `您有 ${count} 条重复数据，请及时处理！`,
  sysRepeatDataWarnDesc: '点击铃铛，进入重复数据列表。',
  sysBasicRequestFail: '获取系统基本数据失败！',

  maxPageTabWarn: '最多可打开 10 个标签页！',
  maxPageTabWarnDesc: '请关闭部分标签页后在操作。'
}
const enUS = {
  home: 'Home',
  userCenter: 'User Center',
  // changePassword: 'Change Password',
  orgMana: 'Organizational Management',
  personalMana: 'Personnel Management',
  newPersonal: 'Add Person',
  editPersonal: 'Edit Person',
  editAuth: 'Authorize',
  authBatch: 'Volume Licensees',
  devicesMana: 'Device Management',
  deviceActiveTime: 'Device Active Time',
  deviceConfig: 'Device Configuration',
  timeConfig: 'Time Configuration',
  visitorMana: 'Visitor Management',
  visitorSettings: 'Visitor Settings',
  reservedVisitor: 'Reservation Record',
  visitorRecord: 'Visited Record',
  visitorPath: 'Visitor Path Palnning',
  blackList: 'Blacklist',
  identificationRecord: 'Identification Record',
  warningMana: 'Warning Record',
  alarmMana: 'Alarm Record',
  logMana: 'Log Management',
  operationLog: 'Operation Log',
  workLog: 'Work Log',
  syncLog: 'Sync Log',
  repeatData: 'Repeating Querys',
  financial: 'Financial',
  recharge: 'Recharge',
  orders: 'Orders',
  invoices: 'Invoices',
  invoicesApply: 'InvoicesApply',
  sysRepeatDataWarn: (count) => `You have ${count} repeating data，please deal with them timely!`,
  sysRepeatDataWarnDesc: 'Click bell to repeating  data list!',
  sysBasicRequestFail: 'Request basic data of system failed!',
  serviceLog: '短信账户变动记录',
  maxPageTabWarn: 'Up to 10 tabs open!',
  maxPageTabWarnDesc: 'Please close part of the tabs.'
}

export default { zhCN, enUS }
